const HandleLogoError = (e) => {
  try {
    const url = new URL(e.target.src);
    const pathname = url.pathname;
    if (!e.target.dataset.triedFallback) {
      e.target.dataset.triedFallback = "true";
      if (pathname.endsWith('.svg')) {
        url.pathname = pathname.replace(/\.svg$/, '.png');
        e.target.src = url.toString();
      } else if (pathname.endsWith('.png')) {
        url.pathname = pathname.replace(/\.png$/, '.svg');
        e.target.src = url.toString();
      }
    }
  } catch (error) {
    const currentSrc = e.target.src;
    if (!e.target.dataset.triedFallback) {
      e.target.dataset.triedFallback = "true";
      if (currentSrc.includes('.svg')) {
        e.target.src = currentSrc.replace('.svg', '.png');
      } else if (currentSrc.includes('.png')) {
        e.target.src = currentSrc.replace('.png', '.svg');
      }
    }
  }
};

export const getLogoUrl = (logoName) => {
  if (!logoName) return "";
  if (logoName.startsWith("http://") || logoName.startsWith("https://")) {
    return logoName;
  }
  const cleanName = logoName.startsWith("/") ? logoName.substring(1) : logoName;
  if (cleanName.startsWith("images/")) {
    return `/${cleanName}?v=7`;
  }
  return `/images/${cleanName}?v=7`;
};

export default HandleLogoError;

